// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { footerCopyrightContainerStyles } from "@steiner/App/Components/Footer/FooterCopyrightContainer";
import { color, layoutContainer, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

footerCopyrightContainerStyles.container = {
    css: css`
        background: ${color("primary")};
    `,
};

footerCopyrightContainerStyles.innerContainer = {
    css: css`
        padding-top: 16px;
        padding-bottom: 16px;

        display: flex;
        align-items: center;
        gap: 16px 22px;
        justify-content: space-between;
        ${layoutContainer}

        ${xScreen("lte", "md")} {
            flex-direction: column;
        }
    `,
};

footerCopyrightContainerStyles.copyright = {
    size: 12,
    weight: "normal",
    color: "common.white",
    css: css`
        line-height: 17px;
    `,
};
